module.exports = __webpack_public_path__ + "fonts/lato-lightitalic-webfont.a7889e0f.woff2";